import angular from 'angular';

import component from './attribute-phone-preview.component';

const AttributePhonePreview = angular
    .module('control-room.commons.content.components.attribute-phone-preview', [])
    .component('crAttributePhonePreview', component);

export default AttributePhonePreview;
